import BackArrow from '@mui/icons-material/ArrowBack';
import Link from './Link.jsx';
import React from 'react';
import {Typography} from '@mui/material';

export const HomeLink = () => {
  return (
    <Link to="/" sx={{display: 'flex', alignItems: 'center'}}>
      <BackArrow className="back-arrow" sx={{marginRight: 1}} />
      <Typography variant="caption">Back to subscriptions</Typography>
    </Link>
  );
};
